import { render, staticRenderFns } from "./zyzzc_details.vue?vue&type=template&id=4d720a08&scoped=true&"
import script from "./zyzzc_details.vue?vue&type=script&lang=js&"
export * from "./zyzzc_details.vue?vue&type=script&lang=js&"
import style0 from "./zyzzc_details.vue?vue&type=style&index=0&id=4d720a08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d720a08",
  null
  
)

export default component.exports